import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getWorkflowCase,
  listWorkflowCases,
  updatePreviousApprovalWithoutStagesNote,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** Updates or clears a preserved approval note that has no stage identity. */
export function useUpdatePreviousApprovalWithoutStagesNote(
  caseId: string,
): InvalidatingMutationResultFor<
  typeof updatePreviousApprovalWithoutStagesNote
> {
  return useInvalidatingMutation(updatePreviousApprovalWithoutStagesNote, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
